// MatchLineup.jsx

function generateFormation(players = [], formation = "4-3-3") {
    const formationNumbers = formation.split("-").map(Number);

    const rows = [];

    let startIndex = 0;

    // Goalkeeper
    rows.push([
        {
            name: players?.[0]?.lineup_player || "",
            number: players?.[0]?.lineup_number || "",
            pos: "GK",
        },
    ]);

    startIndex = 1;

    formationNumbers.forEach((count, rowIndex) => {
        const rowPlayers = [];

        for (let i = 0; i < count; i++) {
            const player = players[startIndex + i];

            if (player) {
                rowPlayers.push({
                    name: player.lineup_player,
                    number: player.lineup_number,
                    pos:
                        rowIndex === 0
                            ? "DEF"
                            : rowIndex === formationNumbers.length - 1
                                ? "ATT"
                                : "MID",
                });
            }
        }

        rows.push(rowPlayers);

        startIndex += count;
    });

    return rows.reverse();
}

function PlayerCard({ player, color }) {
    return (
        <div className="flex flex-col items-center min-w-[55px]">

            <div className="relative flex items-center justify-center text-white font-bold shadow-lg">

                <svg
                    viewBox="0 0 52 56"
                    width="36"
                    height="39"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{
                        filter:
                            "drop-shadow(rgba(0, 0, 0, 0.5) 0px 2px 3px)",
                    }}
                >
                    <path
                        d="M0,12 L6,8 L16,16 L14,26 L4,24 Z"
                        fill={color}
                        stroke="#fde68a"
                        strokeWidth="1.2"
                        strokeLinejoin="round"
                    />

                    <path
                        d="M52,12 L46,8 L36,16 L38,26 L48,24 Z"
                        fill={color}
                        stroke="#fde68a"
                        strokeWidth="1.2"
                        strokeLinejoin="round"
                    />

                    <path
                        d="M16,4 C18,1 22,0 26,0 C30,0 34,1 36,4 L46,8 L36,16 L36,54 L16,54 L16,16 L6,8 Z"
                        fill={color}
                        stroke="#fde68a"
                        strokeWidth="1.2"
                        strokeLinejoin="round"
                    />

                    <text
                        x="26"
                        y="38"
                        textAnchor="middle"
                        dominantBaseline="middle"
                        fill="#fde68a"
                        fontSize="15"
                        fontWeight="900"
                    >
                        {player.number}
                    </text>
                </svg>

            </div>

            <span className="text-white text-[10px] font-semibold truncate max-w-[70px] text-center">
                {player.name}
            </span>

            <span className="text-white/60 text-[8px]">
                {player.pos}
            </span>

        </div>
    );
}

function TeamLineup({ team }) {
    return (
        <div className="space-y-3">

            {/* Header */}
            <div className="flex justify-center items-center gap-2">

                <img
                    src={team.logo}
                    alt={team.name}
                    className="w-8 h-8 object-contain"
                />

                <span className="text-white font-bold text-lg">
                    {team.name}
                </span>

                <span
                    className="px-2 py-1 rounded text-xs"
                    style={{
                        background: team.color,
                        color: "white",
                    }}
                >
                    {team.formation}
                </span>

            </div>

            {/* Formation */}
            {team.players.map((row, i) => (
                <div
                    key={i}
                    className="flex justify-around items-center py-3"
                >
                    {row.map((player, index) => (
                        <PlayerCard
                            key={index}
                            player={player}
                            color={team.color}
                        />
                    ))}
                </div>
            ))}

            {/* Coach */}
            <div className="text-center mt-4">

                <span className="text-white/60 text-xs">
                    Coach
                </span>

                <div className="text-white font-semibold">
                    {team.coach}
                </div>

            </div>

            {/* Substitutes */}
            <div className="mt-4">

                <h4 className="text-white font-semibold mb-2 text-sm">
                    Substitutes
                </h4>

                <div className="flex flex-wrap gap-2 justify-center">

                    {team.substitutes?.map((sub, i) => (
                        <div
                            key={i}
                            className="bg-white/10 border border-white/10 rounded-lg px-2 py-1 text-white text-xs"
                        >
                            #{sub.lineup_number} {sub.lineup_player}
                        </div>
                    ))}

                </div>

            </div>

        </div>
    );
}

export default function MatchLineup({ lineup }) {

    // Get first object key

    const data = lineup

    if (!data) {
        return (
            <div className="text-center py-10 text-gray-500">
                No lineup found
            </div>
        );
    }

    // Home Team
    const homeFormation = "4-4-2";

    const homeTeam = {
        name: "HOME",
        logo: "https://cdn-icons-png.flaticon.com/512/53/53283.png",
        formation: homeFormation,
        color: "#991b1b",
        players: generateFormation(
            data.home.starting_lineups,
            homeFormation
        ),
        coach:
            data.home.coach?.[0]?.lineup_player || "N/A",
        substitutes: data.home.substitutes || [],
    };

    // Away Team
    const awayFormation = "4-3-3";

    const awayTeam = {
        name: "AWAY",
        logo: "https://cdn-icons-png.flaticon.com/512/53/53283.png",
        formation: awayFormation,
        color: "#1e3a8a",
        players: generateFormation(
            data.away.starting_lineups,
            awayFormation
        ),
        coach:
            data.away.coach?.[0]?.lineup_player || "N/A",
        substitutes: data.away.substitutes || [],
    };

    return (
        <div
            className="
                rounded-2xl
                overflow-auto
                p-4
                min-h-[700px]
                bg-gradient-to-b
                from-green-900
                via-green-700
                to-green-900
            "
        >

            {/* Home */}
            <TeamLineup team={homeTeam} />

            <div className="my-6 border border-white/20" />

            {/* Away */}
            <TeamLineup team={awayTeam} />

        </div>
    );
}